import LoadingOverlay from './loading-overlay';
import RequestHandler from './utils/request-handler';
const EVENT_NAMESPACE = 'deliveryOptionDecision';
let checkedValidatePromotions = 'not-checked';
export default class DeliveryOptions {
    constructor() {
        this.submitForm = document.querySelector('form#basket-form button');
        this.decisionElements = document.querySelectorAll('[data-delivery-option-decision]');
        this.inputElements = document.querySelectorAll('[data-delivery-option-input]');
        this.responseMessage = document.querySelector('[data-delivery-option-response-message]');
        this.requestHandler = new RequestHandler;
        this.loadingOverlay = new LoadingOverlay;
    }
    setup() {
        this.setupInputsListener();
        this.setupSubmitButtonListener();
    }
    setupInputsListener() {
        this.inputElements.forEach((el) => {
            this.deliveryOptionAjaxCall(el, EVENT_NAMESPACE);
        });
    }
    setupSubmitButtonListener() {
        this.submitForm.addEventListener('click', (e) => {
            this.submitFormClickHandler(e);
        })
    }
    validateDealsOnCheckOut() {
        let returnData = 'true';
        $.ajax({
            type: 'POST',
            url: '/basket/deal/validation',
            async: false,
            dataType: 'JSON',
            success: function(res) {
                if (res.result == 'false') {
                    returnData = 'false';
                }
            }
        });
        return returnData;
    }
    validatePromotionsBasketOnCheckOut(e) {
        let returnData = 'true';
        if ($('.removePromotion').length) {
            let promoActionValidation = $('#revalidation').attr('href');
            let element = document.querySelector('.global-msg-boxes');
            if (promoActionValidation != '/validating' && checkedValidatePromotions == 'not-checked') {
                checkedValidatePromotions = 'checked';
                $('#revalidation').attr('href', '/validating');
                $.ajax({
                    type: 'POST',
                    url: promoActionValidation,
                    async: false,
                    context: window,
                    dataType: 'JSON',
                    success: function(res) {
                        if (res.result == 'success') {
                            $('.basketTotals').html(res.basketTotalsHtml);
                            $('.promoContent').html(res.promoAppliedHtml);
                            $('.global-msg-boxes').html('<div class="msg-box msg-box-warning"><span class="msg-box-icon"></span>Important: A promotion has been removed as it is no longer valid. Please check your basket for your updated payment total.</div>');
                            element.scrollIntoView(true);
                            e.stopImmediatePropagation();
                            e.preventDefault();
                            jQuery.each(res.basketLine, function(basketId, originalVal) {
                                $('.itemOriginalUpfront_' + basketId).text('');
                                $('.itemDiscountedUpfront_' + basketId).text(originalVal);
                                if ($('.itemDiscountedUpfront_' + basketId).hasClass('itemDiscountedUpfrontSingle')) {
                                    $('.itemDiscountedUpfront_' + basketId).removeClass('itemDiscountedUpfrontSingle');
                                }
                                $('.itemPromoApplied_' + basketId).html('');
                                if ($('.itemPromoApplied_' + basketId).hasClass('accPromoApplied')) {
                                    $('.itemPromoApplied_' + basketId).removeClass('mb-15');
                                }
                            });
                            returnData = 'false';
                        } else if (res.result != 'continue') {
                            $('.global-msg-boxes').html('<div class="msg-box msg-box-warning"><span class="msg-box-icon"></span>Important: A promotion has been removed as it is no longer valid. Please check your basket for your updated payment total.</div>');
                            element.scrollIntoView(true);
                            e.stopImmediatePropagation();
                            e.preventDefault();
                            returnData = 'false';
                        }
                    },
                    error: function() {
                        $('.global-msg-boxes').html('<div class="msg-box msg-box-warning"><span class="msg-box-icon"></span>A technical error has occured, please try again later.</div>');
                        element.scrollIntoView(true);
                        e.stopImmediatePropagation();
                        e.preventDefault();
                        setTimeout(function() {
                            window.location.reload();
                        }, 3000);
                        returnData = 'false';
                    }
                });
            }
        }
        return returnData;
    }
    submitFormClickHandler(e) {
        if (this.validateDealsOnCheckOut() == 'false') {
            window.location.reload();
        } else {
            this.responseMessage.innerText = '';
            if (this.validatePromotionsBasketOnCheckOut(e) == 'false') {
                return;
            }
            let hasSelected = false;
            this.decisionElements.forEach((decisionElem) => {
                if (this.isDecisionChecked(decisionElem)) {
                    hasSelected = true;
                }
            });
            if (!hasSelected) {
                e.preventDefault();
                this.responseMessage.innerText = 'This selection is required';
            }
        }
    }
    responseCallback(response) {
        this.responseMessage.innerText = '';
        if (response.result !== 'success') {
            this.responseMessage.innerText = response.message;
        }
        this.loadingOverlay.taskFinished();
    }
    deliveryOptionAjaxCall(el, name) {
        const inputElem = el;
        el.addEventListener('change', () => {
            const option = inputElem.value;
            if (name !== EVENT_NAMESPACE || !option) {
                return;
            }
            this.toggleActiveOption();
            this.loadingOverlay.taskStarted();
            this.requestHandler.post(
                '/basket/delivery-option',
                {option},
                this.responseCallback.bind(this)
            );
        });
    }
    toggleActiveOption() {
        this.decisionElements.forEach(decisionElem => {
            decisionElem.classList.toggle('active', this.isDecisionChecked(decisionElem));
        });
    }
    isDecisionChecked(decisionElem) {
        return !!decisionElem.querySelector('[data-delivery-option-input]:checked');
    }
}
